import React from "react";

export const ImgCache = (props) => {
    return <img {...props} src={`${props.src}${!props.src.includes("base64") ? `?v=${new Date().toString()}` : ""}`} />
}